import { useEffect, useRef, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';

type ClipMcpResumeProps = {
  // Test seam — window.location.assign is unstubbable under jsdom.
  assignLocation?: (url: string) => void;
};

const ClipMcpResume = ({
  assignLocation = (url) => window.location.assign(url),
}: ClipMcpResumeProps) => {
  const { user } = useAuth();
  const started = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const resume = async () => {
      const apiUrl = import.meta.env.VITE_API_URL;
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(
          `${apiUrl}/integrations/clips/oauth/session`,
          {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
            credentials: 'include',
          },
        );
        if (!response.ok) {
          setFailed(true);
          return;
        }
        assignLocation(
          `${apiUrl}/integrations/clips/oauth/authorize${window.location.search}`,
        );
      } catch {
        setFailed(true);
      }
    };

    void resume();
  }, [assignLocation, user]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      {failed ? (
        <p className="text-sm text-muted-foreground">
          Could not continue authorization. Return to your assistant and try again.
        </p>
      ) : (
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      )}
    </div>
  );
};

export default ClipMcpResume;
